import { defineComponent as _defineComponent } from 'vue';
import { Primitive } from "reka-ui";
import { cn } from '../../primitives/utils';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SidebarMenuAction',
    props: {
        asChild: { type: Boolean, required: false },
        as: { type: null, required: false, default: "button" },
        showOnHover: { type: Boolean, required: false },
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const __returned__ = { props, get Primitive() { return Primitive; }, get cn() { return cn; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
